import { centerCrop, makeAspectCrop } from 'react-image-crop'

const centerAspectCrop = (
	mediaWidth: number,
	mediaHeight: number,
	aspect: number
) => {
	return centerCrop(
		makeAspectCrop(
			{
				unit: '%',
				width: 45,
			},
			aspect,
			mediaWidth,
			mediaHeight
		),
		mediaWidth,
		mediaHeight
	)
}

export { centerAspectCrop }
